var _excluded = ["options", "selectedValue", "disabled", "errorMessage", "hasContainer", "name", "analyticsName", "aria-label", "aria-labelledby", "role", "onClick", "containerProps"],
    _excluded2 = ["value"],
    _excluded3 = ["value"];

function cov_i56qkotng() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/Radio/RadioGroup.tsx";
  var hash = "ba80cfd853a2c8b35f2a37bf63aee3e130f4dcc8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/Radio/RadioGroup.tsx",
    statementMap: {
      "0": {
        start: {
          line: 63,
          column: 81
        },
        end: {
          line: 150,
          column: 1
        }
      },
      "1": {
        start: {
          line: 78,
          column: 29
        },
        end: {
          line: 78,
          column: 51
        }
      },
      "2": {
        start: {
          line: 79,
          column: 24
        },
        end: {
          line: 84,
          column: 4
        }
      },
      "3": {
        start: {
          line: 86,
          column: 2
        },
        end: {
          line: 91,
          column: 46
        }
      },
      "4": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 90,
          column: 5
        }
      },
      "5": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 72
        }
      },
      "6": {
        start: {
          line: 93,
          column: 2
        },
        end: {
          line: 117,
          column: 3
        }
      },
      "7": {
        start: {
          line: 94,
          column: 38
        },
        end: {
          line: 94,
          column: 48
        }
      },
      "8": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 116,
          column: 6
        }
      },
      "9": {
        start: {
          line: 106,
          column: 48
        },
        end: {
          line: 106,
          column: 62
        }
      },
      "10": {
        start: {
          line: 119,
          column: 2
        },
        end: {
          line: 149,
          column: 4
        }
      },
      "11": {
        start: {
          line: 129,
          column: 8
        },
        end: {
          line: 141,
          column: 10
        }
      },
      "12": {
        start: {
          line: 138,
          column: 48
        },
        end: {
          line: 138,
          column: 62
        }
      },
      "13": {
        start: {
          line: 159,
          column: 31
        },
        end: {
          line: 171,
          column: 1
        }
      },
      "14": {
        start: {
          line: 164,
          column: 42
        },
        end: {
          line: 164,
          column: 70
        }
      },
      "15": {
        start: {
          line: 165,
          column: 22
        },
        end: {
          line: 168,
          column: 3
        }
      },
      "16": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 27
        }
      },
      "17": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 61
        }
      },
      "18": {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 170,
          column: 39
        }
      },
      "19": {
        start: {
          line: 177,
          column: 53
        },
        end: {
          line: 180,
          column: 1
        }
      },
      "20": {
        start: {
          line: 178,
          column: 40
        },
        end: {
          line: 178,
          column: 57
        }
      },
      "21": {
        start: {
          line: 179,
          column: 2
        },
        end: {
          line: 179,
          column: 100
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 63,
            column: 81
          },
          end: {
            line: 63,
            column: 82
          }
        },
        loc: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 77
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 86,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        },
        loc: {
          start: {
            line: 86,
            column: 18
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 86
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 106,
            column: 42
          },
          end: {
            line: 106,
            column: 43
          }
        },
        loc: {
          start: {
            line: 106,
            column: 48
          },
          end: {
            line: 106,
            column: 62
          }
        },
        line: 106
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 128,
            column: 19
          },
          end: {
            line: 128,
            column: 20
          }
        },
        loc: {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 141,
            column: 10
          }
        },
        line: 129
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 138,
            column: 42
          },
          end: {
            line: 138,
            column: 43
          }
        },
        loc: {
          start: {
            line: 138,
            column: 48
          },
          end: {
            line: 138,
            column: 62
          }
        },
        line: 138
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 159,
            column: 31
          },
          end: {
            line: 159,
            column: 32
          }
        },
        loc: {
          start: {
            line: 163,
            column: 5
          },
          end: {
            line: 171,
            column: 1
          }
        },
        line: 163
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 162,
            column: 55
          },
          end: {
            line: 162,
            column: 56
          }
        },
        loc: {
          start: {
            line: 162,
            column: 61
          },
          end: {
            line: 162,
            column: 63
          }
        },
        line: 162
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 165,
            column: 22
          },
          end: {
            line: 165,
            column: 23
          }
        },
        loc: {
          start: {
            line: 165,
            column: 41
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 165
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 177,
            column: 53
          },
          end: {
            line: 177,
            column: 54
          }
        },
        loc: {
          start: {
            line: 177,
            column: 64
          },
          end: {
            line: 180,
            column: 1
          }
        },
        line: 177
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 65,
            column: 18
          },
          end: {
            line: 65,
            column: 20
          }
        }],
        line: 65
      },
      "1": {
        loc: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 73,
            column: 9
          },
          end: {
            line: 73,
            column: 21
          }
        }],
        line: 73
      },
      "2": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 88
      },
      "3": {
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 21
          }
        }, {
          start: {
            line: 88,
            column: 25
          },
          end: {
            line: 88,
            column: 31
          }
        }],
        line: 88
      },
      "4": {
        loc: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 93
      },
      "5": {
        loc: {
          start: {
            line: 106,
            column: 19
          },
          end: {
            line: 106,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 30
          },
          end: {
            line: 106,
            column: 39
          }
        }, {
          start: {
            line: 106,
            column: 42
          },
          end: {
            line: 106,
            column: 62
          }
        }],
        line: 106
      },
      "6": {
        loc: {
          start: {
            line: 110,
            column: 9
          },
          end: {
            line: 114,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 10
          },
          end: {
            line: 113,
            column: 17
          }
        }, {
          start: {
            line: 114,
            column: 12
          },
          end: {
            line: 114,
            column: 16
          }
        }],
        line: 110
      },
      "7": {
        loc: {
          start: {
            line: 123,
            column: 12
          },
          end: {
            line: 123,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 123,
            column: 29
          },
          end: {
            line: 123,
            column: 33
          }
        }, {
          start: {
            line: 123,
            column: 36
          },
          end: {
            line: 123,
            column: 45
          }
        }],
        line: 123
      },
      "8": {
        loc: {
          start: {
            line: 138,
            column: 19
          },
          end: {
            line: 138,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 30
          },
          end: {
            line: 138,
            column: 39
          }
        }, {
          start: {
            line: 138,
            column: 42
          },
          end: {
            line: 138,
            column: 62
          }
        }],
        line: 138
      },
      "9": {
        loc: {
          start: {
            line: 143,
            column: 7
          },
          end: {
            line: 147,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 146,
            column: 15
          }
        }, {
          start: {
            line: 147,
            column: 10
          },
          end: {
            line: 147,
            column: 14
          }
        }],
        line: 143
      },
      "10": {
        loc: {
          start: {
            line: 161,
            column: 2
          },
          end: {
            line: 161,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 161,
            column: 25
          },
          end: {
            line: 161,
            column: 27
          }
        }],
        line: 161
      },
      "11": {
        loc: {
          start: {
            line: 162,
            column: 2
          },
          end: {
            line: 162,
            column: 63
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 162,
            column: 55
          },
          end: {
            line: 162,
            column: 63
          }
        }],
        line: 162
      },
      "12": {
        loc: {
          start: {
            line: 164,
            column: 51
          },
          end: {
            line: 164,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 51
          },
          end: {
            line: 164,
            column: 63
          }
        }, {
          start: {
            line: 164,
            column: 67
          },
          end: {
            line: 164,
            column: 69
          }
        }],
        line: 164
      },
      "13": {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 167,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 167,
            column: 11
          }
        }, {
          start: {
            line: 167,
            column: 15
          },
          end: {
            line: 167,
            column: 60
          }
        }],
        line: 167
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0],
      "11": [0],
      "12": [0, 0],
      "13": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ba80cfd853a2c8b35f2a37bf63aee3e130f4dcc8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_i56qkotng = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_i56qkotng();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Text, Flex } from '../../index';
import { useObservabilitySafe } from '../../../hooks/useObservabilitySafe';
import { Radio } from '../CheckboxOrRadio';
cov_i56qkotng().s[0]++;

/**
 * OPTION 1: PRESENTATIONAL RADIO GROUP
 * Radio Group is purely presentational
 * This does not handle keeping track of selected values handleChange & handleClick. Consumer must handle these themselves.
 * If you would like the bricks component to handle this please use RadioGroup which is a combination of PresentationalRadioGroup & the hook with default logic
 */
export var PresentationalRadioGroup = function PresentationalRadioGroup(_ref) {
  var options = _ref.options,
      _ref$selectedValue = _ref.selectedValue,
      selectedValue = _ref$selectedValue === void 0 ? (cov_i56qkotng().b[0][0]++, '') : _ref$selectedValue,
      disabled = _ref.disabled,
      errorMessage = _ref.errorMessage,
      hasContainer = _ref.hasContainer,
      name = _ref.name,
      analyticsName = _ref.analyticsName,
      ariaLabel = _ref['aria-label'],
      ariaLabelBy = _ref['aria-labelledby'],
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? (cov_i56qkotng().b[1][0]++, 'radiogroup') : _ref$role,
      onClick = _ref.onClick,
      containerProps = _ref.containerProps,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_i56qkotng().f[0]++;

  var _ref2 = (cov_i56qkotng().s[1]++, useObservabilitySafe()),
      trackUserEvent = _ref2.trackUserEvent;

  var _ref3 = (cov_i56qkotng().s[2]++, useInView({
    // https://react-intersection-observer.vercel.app/?path=/docs/useinview-hook--basic
    // threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering. (set at 100% for now)
    threshold: 1,
    skip: !analyticsName
  })),
      _ref4 = _slicedToArray(_ref3, 2),
      ref = _ref4[0],
      inView = _ref4[1];

  cov_i56qkotng().s[3]++;
  useEffect(function () {
    cov_i56qkotng().f[1]++;
    cov_i56qkotng().s[4]++;

    // this tracks impression events whenenver the button enters or leaves the viewpoint
    if ((cov_i56qkotng().b[3][0]++, analyticsName) && (cov_i56qkotng().b[3][1]++, inView)) {
      cov_i56qkotng().b[2][0]++;
      cov_i56qkotng().s[5]++;
      trackUserEvent({
        radioViewEvent: {
          targetName: analyticsName
        }
      });
    } else {
      cov_i56qkotng().b[2][1]++;
    }
  }, [analyticsName, inView, trackUserEvent]);
  cov_i56qkotng().s[6]++;

  if (options.length === 1) {
    cov_i56qkotng().b[4][0]++;

    var _ref5 = (cov_i56qkotng().s[7]++, options[0]),
        _value = _ref5.value,
        optionProps = _objectWithoutProperties(_ref5, _excluded2);

    cov_i56qkotng().s[8]++;
    return /*#__PURE__*/React.createElement(Flex, _extends({
      ref: ref,
      flexDirection: "column"
    }, containerProps), /*#__PURE__*/React.createElement(Radio, _extends({
      analyticsName: analyticsName,
      checked: selectedValue === _value,
      disabled: disabled,
      errorMessage: errorMessage,
      hasContainer: hasContainer,
      key: _value,
      name: name,
      value: _value,
      onClick: disabled ? (cov_i56qkotng().b[5][0]++, undefined) : (cov_i56qkotng().b[5][1]++, function () {
        cov_i56qkotng().f[2]++;
        cov_i56qkotng().s[9]++;
        return onClick(_value);
      })
    }, optionProps, props)), errorMessage !== undefined ? (cov_i56qkotng().b[6][0]++, /*#__PURE__*/React.createElement(Text, {
      color: "red50",
      fontSize: "s1",
      "data-testid": 'error messaging'
    }, errorMessage)) : (cov_i56qkotng().b[6][1]++, null));
  } else {
    cov_i56qkotng().b[4][1]++;
  }

  cov_i56qkotng().s[10]++;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    ref: ref,
    flexDirection: "column",
    role: role != 'none' ? (cov_i56qkotng().b[7][0]++, role) : (cov_i56qkotng().b[7][1]++, undefined),
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelBy
  }, containerProps), options.map(function (_ref6) {
    var value = _ref6.value,
        optionProps = _objectWithoutProperties(_ref6, _excluded3);

    cov_i56qkotng().f[3]++;
    cov_i56qkotng().s[11]++;
    return /*#__PURE__*/React.createElement(Radio, _extends({
      analyticsName: analyticsName,
      checked: selectedValue === value,
      disabled: disabled,
      errorMessage: errorMessage,
      hasContainer: hasContainer,
      key: value,
      name: name,
      value: value,
      onClick: disabled ? (cov_i56qkotng().b[8][0]++, undefined) : (cov_i56qkotng().b[8][1]++, function () {
        cov_i56qkotng().f[4]++;
        cov_i56qkotng().s[12]++;
        return onClick(value);
      })
    }, optionProps, props));
  }), errorMessage !== undefined ? (cov_i56qkotng().b[9][0]++, /*#__PURE__*/React.createElement(Text, {
    color: "red50",
    fontSize: "s1",
    "data-testid": 'error messaging'
  }, errorMessage)) : (cov_i56qkotng().b[9][1]++, null));
};
/**
 * This hook handles keeping track of selected values & the handleClick.
 * It is used in the stateful radio group that handles all the default logic for the consumer
 * useRadioHandler handles:
 *   1) default radio handling logic
 *   2) keeps track of checked values
 */

cov_i56qkotng().s[13]++;
export var useRadioHandler = function useRadioHandler() {
  var _ref9;

  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_i56qkotng().b[10][0]++, '');
  var onClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_i56qkotng().b[11][0]++, function () {
    cov_i56qkotng().f[6]++;
  });
  cov_i56qkotng().f[5]++;

  var _ref7 = (cov_i56qkotng().s[14]++, useState((_ref9 = (cov_i56qkotng().b[12][0]++, initialValue)) !== null && _ref9 !== void 0 ? _ref9 : (cov_i56qkotng().b[12][1]++, ''))),
      _ref8 = _slicedToArray(_ref7, 2),
      checkedValue = _ref8[0],
      setCheckedValue = _ref8[1];

  cov_i56qkotng().s[15]++;

  var handleClick = function handleClick(value) {
    cov_i56qkotng().f[7]++;
    cov_i56qkotng().s[16]++;
    setCheckedValue(value);
    cov_i56qkotng().s[17]++;
    (cov_i56qkotng().b[13][0]++, onClick) && (cov_i56qkotng().b[13][1]++, onClick(checkedValue, checkedValue === value));
  };

  cov_i56qkotng().s[18]++;
  return {
    checkedValue: checkedValue,
    handleClick: handleClick
  };
};
/**
 * OPTION 2: STATEFUL RADIO GROUP: A stateful radio group that handles all the default logic for the consumer
 *   This radio group keeps track of selected values & the handleClick by calling the useRadioHandler
 */

cov_i56qkotng().s[19]++;
export var RadioGroup = function RadioGroup(props) {
  cov_i56qkotng().f[8]++;

  var _ref10 = (cov_i56qkotng().s[20]++, useRadioHandler()),
      checkedValue = _ref10.checkedValue,
      handleClick = _ref10.handleClick;

  cov_i56qkotng().s[21]++;
  return /*#__PURE__*/React.createElement(PresentationalRadioGroup, _extends({
    selectedValue: checkedValue,
    onClick: handleClick
  }, props));
};